import axios from 'axios';
import apiConfig from "./config";

const { apiURL } = apiConfig;

const api = axios.create({
  baseURL: apiURL
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('login-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api
